import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    preset: {
      type: String,
      default: undefined
    },

    range: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      showMenu: false,
      isPresetChangeInProgress: false
    }
  },

  computed: {
    pattern() {
      return this.proxy?.pattern?.replace(/[\n\r]/gm, ' ')
    }
  },

  watch: {
    showMenu() {
      const textarea = this.$refs.pattern.$el.querySelector('textarea')
      if (textarea) {
        this.$nextTick(() => {
          return textarea.focus()
        })
      }
    }
  },

  render
}
